// extracted by mini-css-extract-plugin
export var archiveCard = "archiveCard-module--archiveCard--e89b2 archiveCard-module--archiveCardShadow--15741";
export var archiveCardShadow = "archiveCard-module--archiveCardShadow--15741";
export var cardHeader = "archiveCard-module--cardHeader--afa33";
export var cardHeaderText = "archiveCard-module--cardHeaderText--057ac";
export var klaviyoFlag = "archiveCard-module--klaviyoFlag--cbea1";
export var lightSand = "archiveCard-module--lightSand--c8c5f archiveCard-module--archiveCard--e89b2 archiveCard-module--archiveCardShadow--15741";
export var postSubText = "archiveCard-module--postSubText--ba810";
export var postText = "archiveCard-module--postText--8f33a";
export var postTitle = "archiveCard-module--postTitle--cdfbf";
export var white = "archiveCard-module--white--11950 archiveCard-module--archiveCard--e89b2 archiveCard-module--archiveCardShadow--15741";